export default __webpack_public_path__ + "static/media/cabinet1-before-480w.8072c6f3.avif";